module.exports = __webpack_public_path__ + "static/media/galleryGT (3).877e96de.jpg";